'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { jsx as _jsx } from "react/jsx-runtime";
export default class AppReadyComponent extends Component {
  render() {
    const {
      fallbackComponent,
      isReady,
      isUniversalAppReady
    } = this.props;
    if (isReady && !EditorConfigSingleton.getIsOnScalableEditor() || isUniversalAppReady) {
      return this.props.children;
    }
    return fallbackComponent || /*#__PURE__*/_jsx("span", {});
  }
}
AppReadyComponent.propTypes = {
  children: PropTypes.node,
  fallbackComponent: PropTypes.node,
  isReady: PropTypes.bool.isRequired,
  isUniversalAppReady: PropTypes.bool.isRequired
};
AppReadyComponent.defaultProps = {
  isUniversalAppReady: false
};